import { NotificationSettings } from 'types/User';
import { objectKeysToCamelCase, objectKeysToSnakeCase } from 'utils/common';

import erlClient from '.';
import { RegionKey } from './regions';

export const getNotificationSettings = async (portCollection?: RegionKey, signal?: AbortSignal) => {
  const res = await erlClient.get('/core/api/v1/notification/settings', {
    signal,
    params: objectKeysToSnakeCase({ portCollection }),
  });
  return objectKeysToCamelCase(res.data) as NotificationSettings;
};

export const updateNotificationSettings = async ({ values }: { values: NotificationSettings }) => {
  const res = await erlClient.put(
    '/core/api/v1/notification/settings',
    objectKeysToSnakeCase(values)
  );
  return objectKeysToCamelCase(res.data) as NotificationSettings;
};
